var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconamoon:search-light",
    clipPath: "url(#clip0_942_3349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6 14.6001L11.4151 11.4152M11.4151 11.4152C11.9599 10.8704 12.3921 10.2236 12.6869 9.51185C12.9817 8.80006 13.1335 8.03716 13.1335 7.26672C13.1335 6.49628 12.9817 5.73338 12.6869 5.02159C12.3921 4.30979 11.9599 3.66304 11.4151 3.11825C10.8703 2.57347 10.2236 2.14132 9.51179 1.84649C8.8 1.55165 8.0371 1.3999 7.26666 1.3999C6.49622 1.3999 5.73332 1.55165 5.02153 1.84649C4.30973 2.14132 3.66298 2.57347 3.11819 3.11825C2.01795 4.2185 1.39984 5.71074 1.39984 7.26672C1.39984 8.8227 2.01795 10.3149 3.11819 11.4152C4.21843 12.5154 5.71068 13.1335 7.26666 13.1335C8.82264 13.1335 10.3149 12.5154 11.4151 11.4152Z",
    stroke: "#3B3B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_942_3349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1f72fe3efd671b6a5c8071bd36cdd9ff.svg";
export { ForwardRef as ReactComponent };